(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.surface = this.querySelector('.ba');
        this.handle = this.querySelector('.ba__handle');
        if (!this.surface || !this.handle) return;

        this.dragging = false;
        this._move = (e) => {
          if (this.dragging) this.setFromX(e.clientX);
        };
        this._up = () => {
          this.dragging = false;
          this.surface.classList.remove('is-dragging');
          window.removeEventListener('pointermove', this._move);
          window.removeEventListener('pointerup', this._up);
        };

        this.surface.addEventListener('pointerdown', (e) => {
          this.dragging = true;
          this.surface.classList.add('is-dragging');
          if (this.handle.focus) this.handle.focus({ preventScroll: true });
          this.setFromX(e.clientX);
          window.addEventListener('pointermove', this._move);
          window.addEventListener('pointerup', this._up);
        });

        this.handle.addEventListener('keydown', (e) => {
          const step = e.shiftKey ? 10 : 2;
          let pos = parseFloat(this.handle.getAttribute('aria-valuenow'));
          if (isNaN(pos)) pos = 50;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') pos -= step;
          else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') pos += step;
          else if (e.key === 'Home') pos = 0;
          else if (e.key === 'End') pos = 100;
          else return;
          e.preventDefault();
          this.setPos(pos);
        });
      }

      setFromX(x) {
        const rect = this.surface.getBoundingClientRect();
        if (rect.width) this.setPos(((x - rect.left) / rect.width) * 100);
      }

      setPos(p) {
        p = Math.max(0, Math.min(100, p));
        this.surface.style.setProperty('--pos', p + '%');
        this.handle.setAttribute('aria-valuenow', Math.round(p));
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
